import type { Entity } from '@backstage/catalog-model';
import { stackSupports } from '@internal/plugin-stack-common';

/**
 * Whether the Monitoring tab is offered for `entity`.
 *
 * Capability only, and deliberately not "capability AND a Grafana
 * integration". The sibling Console and Storage Lifecycle tabs do test their
 * integration, because a bucket can never have a console and a VM can never
 * have an object-retention policy - there the tab could only ever report the
 * obvious. Monitoring is different: a monitoring-capable machine whose tenant
 * has no dashboard is a platform configuration gap, not an impossibility, and
 * hiding the tab left the tenant unable to tell "monitoring is not set up for
 * us" from "this portal does not do monitoring at all" (#14956).
 *
 * The tab therefore stays, and `StackGrafanaContent` says plainly that
 * monitoring is not configured for the tenant.
 */
export function showsMonitoringTab(entity: Entity): boolean {
  return stackSupports(entity, 'monitoring');
}
